import * as plugins from '../plugins.js';
import * as authInterfaces from '../data/auth.js';
import * as configEventInterfaces from '../data/config-events.js';

// List platform configuration events
export interface IReq_ListConfigEvents extends plugins.typedrequestInterfaces.implementsTR<
  plugins.typedrequestInterfaces.ITypedRequest,
  IReq_ListConfigEvents
> {
  method: 'listConfigEvents';
  request: {
    identity?: authInterfaces.IIdentity;
    apiToken?: string;
    /** Filter by acknowledgement state; omit for all events. */
    acknowledged?: boolean;
    severity?: configEventInterfaces.TOpsConfigEventSeverity;
    category?: string;
    limit?: number;
    cursor?: configEventInterfaces.IOpsConfigEventCursor;
  };
  response: {
    events: configEventInterfaces.IOpsConfigEvent[];
    total: number;
    unacknowledgedCount: number;
    nextCursor?: configEventInterfaces.IOpsConfigEventCursor;
  };
}

// Acknowledge platform configuration events
export interface IReq_AcknowledgeConfigEvents extends plugins.typedrequestInterfaces.implementsTR<
  plugins.typedrequestInterfaces.ITypedRequest,
  IReq_AcknowledgeConfigEvents
> {
  method: 'acknowledgeConfigEvents';
  request: {
    identity?: authInterfaces.IIdentity;
    apiToken?: string;
    ids: string[];
  };
  response: {
    success: boolean;
    acknowledgedCount: number;
    message?: string;
  };
}
